"use strict";

/* Directives */
_BannerFlowApp.directive("editable", function () {
    return {
        restrict: "A",
        require: "?ngModel",
        controller: function ($scope, $attrs) {},
        link: function (scope, element, attrs, ngModel) {
            if (!ngModel) return;

            var allowEmpty = attrs.allowEmpty ? attrs.allowEmpty : false;
            var placeholder = attrs.placeholder ? attrs.placeholder : "";
            var standardText = attrs.standardText ? attrs.standardText : "";
            var atLeastOneAlphaNumeric = attrs.atLeastOneAlphaNumeric
                ? attrs.atLeastOneAlphaNumeric
                : false;

            var originalText = "";

            element.addClass("editable");
            element.after(
                $(
                    "<i class='fa fa-pencil' style='color: rgba(255,255,255,0.5);font-size: 25px;margin-left:10px;'></i>"
                )
            );
            element.attr("spellcheck", "false");
            element.hallo({
                placeholder: placeholder,
                plugins: {
                    halloblacklist: ["br"],
                    cleanText: {
                        maxChar: 100
                    }
                }
            });

            element.css({ "min-height": "50px" });

            element.on("halloactivated", function (e) {
                originalText = element.text();
                if (standardText === "") return;

                if (element.text() === standardText) {
                    element.text("");
                }
            });

            element.on("hallodeactivated", function (e) {
                if (
                    atLeastOneAlphaNumeric &&
                    !/\d/.test(element.text()) &&
                    !/[a-zA-Z]/.test(element.text())
                ) {
                    element.text(originalText);
                    return;
                }

                if (element.text() === "" && !allowEmpty) {
                    element.text(ngModel.$viewValue);
                    return;
                }

                ngModel.$setViewValue(element.text());
                scope.$apply();
            });

            ngModel.$render = function () {
                element.html(ngModel.$viewValue || placeholder);
            };
        }
    };
});
